import { Button, Dropdown, Menu, MenuProps, Segmented } from 'antd';
import { AnimatePresence, motion } from 'framer-motion';
import LoadingIndicator from 'components/LoadingIndicator';
import { Viewport } from 'components/ViewportProvider';
// import MainCategoryNavMobile from 'containers/MainCategoryMobile';
import VisuallyHidden from 'components/VisuallyHidden';
import usePopstateLanguage from 'hooks/usePopStateLanguage';
import debounce from 'lodash/debounce';
import qs from 'qs';
import React, { FC, Suspense, lazy, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import translations from 'translations';
import { Buyer, Category, GetTrendingSearchForGuestUserResponse, Language, Store } from 'types/schema';
import { createSearchQueryfromSlug, getPathSegmentFromSlug } from 'utils/getPathSegmentFromSlug';
import messages from 'utils/messages';
import { viewPermissions } from 'utils/permissionMap';
import { parse, stringify } from 'utils/queryString';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';
import { pathnameChecker } from 'utils/url';
import CategoryMegaMenu from '../../containers/CategoryMegaMenu';
import SVGIcon from '../SVGIcon/SVGIcon';
import Cart from './CartV3.svg';
import CheckIcon from './CheckIcon.svg';
import GlobalIcon from './NavIcons/GlobalIcon.svg';
import InvoiceIcon from './NavIcons/InvoiceIcon.svg';
import ReturnIcon from './NavIcons/ReturnIcon.svg';
import SupportIcon from './NavIcons/SupportIcon.svg';
import TruckIcon from './NavIcons/TruckIcon.svg';

import FarmToBusinessHeader from './FarmToBusinessHeader';
import FavoriteIcon from './FavoriteV3.svg';
import HomePageBottomHeader from './HomePageBottomHeader';
import Kamereo from './Kamereo.svg';
import KamereoInfo from './KamereoInfo';
import { LocationIcon } from './Location';
import topNavMessage from './messages';
import HamburgerIcon from './NavIcons/HamburgerIcon';
import KamereoLogoMobileWhite from './NavIcons/KamereoLogoMobileWhite.svg';
import KamereoMascotOnly from './NavIcons/KamereoMascotOnly.svg';
import Notification from './NavIcons/NotificationIcon';
import SearchIcon from './NavIcons/SearchIcon.svg';
import { SEARCH_HISTORY_KEY } from './SearchWithDropDown';
import './topNav.css';
import TopNavCategory from './TopNavCategory';

import { default as ArrowDown, default as ArrowDownIcon } from './NavIcons/ArrowDown';
import CategoriesNavIcon from './NavIcons/CategoriesNavIcon';
import RestaurantIcon from './NavIcons/RestaurantIcon';
import QuickOrderLink from './QuickOrderLink';
import {
  AntdInput,
  CustomSearchInput,
  EnvIndicator,
  InputContainer,
  KamereoLogo,
  LeftNav,
  LinkText,
  MenuItem,
  MenuItemLink,
  MenuLabel,
  MiddleNav,
  /* ProfileInfoContainer, */
  RightNav,
  SignInSignUpWrapper,
  StoreName,
  SwitchRegionContainer,
  SwitchStoreContainer,
  SwitchStoreMobileContainer,
  TopNavBadge,
  TopNavButtonHiddenOnMobile,
  TopNavContent,
  TopNavLinkItem,
  /* TopNavMenuItem, */
  TopNavTopContent,
  TopNavTopContentLeft,
  TopNavTopContentRight,
  TopNavTopContentWrapper,
  TopNavWrapper,
} from './TopNavComponents';

const checkingKeywords = new Set<string>();

const SearchWithDropDown = lazy(() => import('components/MainNav/SearchWithDropDown'));

interface ITopNavProps extends RouteComponentProps {
  opened: boolean;
  user: any;
  store: Store;
  buyer: Buyer & {
    loading: boolean;
  };
  cart: { cartSet: any[] };
  permissions: string[];
  onToggle: () => void | undefined;
  onSignout: () => void | undefined;
  onSetLang: (data: any) => void | undefined;
  categories: Category[];
  hasUnreadNotification: boolean;
  setSearchProductResults: (payload: any) => void;
  clearSearchProductResults: () => void;
  checkBadword: (params: { keyword: string; cb: () => void }) => void;
  handleSaveSearchKeyword: (keyword: string) => void;
  trendingSearchData: GetTrendingSearchForGuestUserResponse;
  onOpenSigninPopup: (value: boolean) => void;
}

interface ISearchProductComponent extends Partial<RouteComponentProps> {
  setSearchProductResults: (payload: any) => void;
  clearSearchProductResults: () => void;
  checkBadword: (params: { keyword: string; cb: () => void }) => void;
  handleSaveSearchKeyword: (keyword: string) => void;
  trendingSearchData: GetTrendingSearchForGuestUserResponse;
}

const LangSwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const LangSwitcher = styled(Segmented)`
  background-color: transparent;
  color: #2f382c;
  padding: 0;
  &.ant-segmented {
    .ant-segmented-group {
      gap: 16px;
    }
    .ant-segmented-item-selected {
      color: #43a047;
      font-size: 14px;
      font-weight: 500;
      border-radius: 4px;
      background: transparent;
      box-shadow: none;
    }
    .ant-segmented-item {
      position: relative;
      &:first-child {
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
      }
      &:first-child::before {
        content: '';
        display: block;
        background: #bfc3cb;
        height: 14px;
        width: 1px;
        margin-left: 8px;
        margin-right: -8px;
      }
      &:after {
        background: transparent !important;
      }
    }
    .ant-segmented-item-label {
      min-height: 22px;
      line-height: 22px;
      padding: 0;
    }
    .ant-segmented-thumb {
      background: transparent;
    }
    .ant-segmented-item:hover:not(.ant-segmented-item-selected):not(.ant-segmented-item-disabled) {
      background: transparent;
      color: #2f382c;
    }

    .ant-segmented-item:active:not(.ant-segmented-item-selected):not(.ant-segmented-item-disabled) {
      background: rgba(0, 0, 0, 0.05);
      color: #2f382c;
    }
  }
`;

export const CategoryIconWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 10px 16px;
  font-size: 15px;
  color: #424242;
  border: none;
  height: fit-content;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #fafafa;
    font-weight: 500;
    border-color: rgba(189, 189, 189, 0.6);
  }

  ${({ isActive }) =>
    isActive &&
    `
    color: #4caf50;
    border-color: #4CAF50 !important;
    background: #fafafa;
    div div svg {
      filter: invert(53%) sepia(9%) saturate(3454%) hue-rotate(73deg) brightness(99%) contrast(68%);
    }
  `}
`;
export const LanguageItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const RegionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const RegionLabel = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #242527;
`;
const HeaderIconWrapper = styled.div`
  position: relative;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #424242;
  &:hover {
    background: #fafafa;
  }
  &.active {
    background: #fafafa;
    color: #4caf50;
  }
`;

export const ChangeRegionContainer = styled.div`
  height: fit-content;
  .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item-selected {
    background: transparent;
    &:hover {
      background: rgba(66, 66, 66, 0.05);
    }
  }
  .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item-divider {
    margin: 0px 12px;
  }
  .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item:not(:last-child) {
    padding: 12px 12px 8px;
  }
  .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item:last-child {
    padding: 8px 12px 12px;
  }
  ${({ isMobile }) =>
    !isMobile &&
    `
    // padding: 0 8px 0 10px;
  `}
`;
const RegionContainer = styled.span`
  line-height: 100%;
  color: #2f382c;
`;
const RegionName = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 100%;
  color: #111827;
`;
const SearchWithDropDownComponent = styled(SearchWithDropDown)`
  position: absolute;
  top: 50px;
  left: 0px;
`;

const FeaturesList = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
`;

const SubBarCategoryToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  cursor: pointer;
  &:hover {
    color: #43a047;
    svg {
      color: #43a047 !important;
    }
  }
`;

const MobileLoginButton = styled.div`
  padding: 5px 12px;
  border: 1px solid #d1d5db;
  border-radius: 80px;
  color: #111827;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  background: #ffffff;
  ${({ bgColor }) =>
    bgColor &&
    `
    background: #43a047;
    border-color: #43a047;
    color: #ffffff;
  `}
`;

const SearchProductComponentMobileWrapper = styled.div`
  padding: 4px 16px 8px;
  background: #ffffff;
  box-shadow:
    0 4px 32px 0 rgba(0, 0, 0, 0.08),
    0 1px 0 0 rgba(0, 0, 0, 0.05);
`;
const debounceInput = debounce((cb) => {
  cb();
}, 300);

/* ******************************************* */
const SideNavMobileComponent = lazy(() => import('./SideNavMobile'));
const TopNavMenuItem = lazy(() => import('./TopNavComponents').then((module) => ({ default: module.TopNavMenuItem })));
const ProfileInfoContainer = lazy(() =>
  import('./TopNavComponents').then((module) => ({ default: module.ProfileInfoContainer })),
);
const MainCategoryNavMobile = lazy(() => import('containers/MainCategoryMobile'));
/* ******************************************* */

const profileMenu = (onSignout: () => void | undefined) => (
  <Menu>
    <Menu.Item key="0">
      <MenuItemLink to="/account-info">
        <MenuLabel>
          <FormattedMessage {...messages.accountSetting} />
        </MenuLabel>
      </MenuItemLink>
    </Menu.Item>
    <Menu.Item key="1">
      <MenuItemLink to="/refer-friends">
        <MenuLabel>
          <FormattedMessage {...topNavMessage.referralMenuItem} />
        </MenuLabel>
      </MenuItemLink>
    </Menu.Item>
    <Menu.Item key="2">
      <MenuItemLink to="/orders">
        <MenuLabel>
          <FormattedMessage {...messages.orderHistory} />
        </MenuLabel>
      </MenuItemLink>
    </Menu.Item>
    <Menu.Item key="3">
      <MenuItemLink to="/overview">
        <MenuLabel>
          <FormattedMessage {...messages.overviewReport} />
        </MenuLabel>
      </MenuItemLink>
    </Menu.Item>
    <Menu.Item key="4">
      <MenuItemLink to="/company-info">
        <MenuLabel>
          <FormattedMessage {...messages.businessSettings} />
        </MenuLabel>
      </MenuItemLink>
    </Menu.Item>
    <Menu.Item key="5">
      <MenuItem color="#FE5043" onClick={onSignout}>
        <MenuLabel>
          <FormattedMessage {...messages.signout} />
        </MenuLabel>
      </MenuItem>
    </Menu.Item>
  </Menu>
);

export const SearchProductComponent: FC<ISearchProductComponent> = (props) => {
  const {
    setSearchProductResults,
    clearSearchProductResults,
    history,
    checkBadword,
    handleSaveSearchKeyword,
    location,
  } = props;

  const [keyword, setKeyWord] = useState<string>('');
  const [tempKeyword, setTempKeyword] = useState('');
  const [isOpenSearchResultDropdown, setIsOpenSearchResultDropdown] = useState(false);
  const [isCheckingBadword, setIsCheckingBadword] = useState<boolean>(false);
  const searchInputContainer = useRef<any>(null);
  const searchInput = useRef<any>(null);
  const loggedIn = !!localStorage.getItem('token');
  const segment = getPathSegmentFromSlug(location);
  const searchQuery = createSearchQueryfromSlug(location, segment);
  const search = parse(searchQuery);

  const onChangeSearch = (event) => {
    if (!keyword && event.target.value.length === 1) {
      sendGA4Event(EventName.SEARCH_TYPING);
    }

    setKeyWord(event.target.value);
    debounceInput(() => {
      if (event.target.value) {
        const query = parse(location?.search);
        setSearchProductResults({
          query: {
            filter: {
              query: event.target.value,
              categoryIds: query?.filter?.categoryIds?.[0] ? [query?.filter?.categoryIds?.[0]] : [],
              // withexclusive: true,
            },
          },
          clearPreviousData: true,
        });
      } else {
        clearSearchProductResults();
      }
      setTempKeyword(event.target.value);
    });
  };

  const handleOnSearch = useCallback(() => {
    if (!keyword) return;
    const searchParams = stringify({
      // ...filterableKeysParams,
      q: keyword || undefined,
      favorite: undefined,
      // withexclusive: true,
    });
    history?.push({
      pathname: `/market`,
      search: searchParams,
    });
    setIsOpenSearchResultDropdown(false);
    searchInput?.current?.blur();
    const cleanKeyword = keyword.trim().toLowerCase();
    const detectRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b|(?:\+84|0)(?:\d{9,10})|\b\d{4,8}\b/i; // check phone number, otp, email
    if (!cleanKeyword || detectRegex.test(cleanKeyword)) return;
    if (!loggedIn) {
      const searchHistory = JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY)?.toString() || '[]');
      if (!searchHistory.includes(cleanKeyword) && !isCheckingBadword && !checkingKeywords.has(cleanKeyword)) {
        setIsCheckingBadword(true);
        checkingKeywords.add(cleanKeyword);
        checkBadword({
          keyword: cleanKeyword,
          cb: () => {
            const updatedHistory = [...searchHistory];
            updatedHistory.unshift(cleanKeyword);
            const newValue = updatedHistory.slice(0, 5);
            localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(newValue));
            setIsCheckingBadword(false);
            checkingKeywords.delete(cleanKeyword);
          },
        });
      }
    } else {
      handleSaveSearchKeyword(cleanKeyword);
    }
    sendGA4Event(EventName.SEARCH_SUBMIT, {
      keyword: keyword,
      keyword_length: keyword?.trim().length,
      filters_applied: false,
      source: 'manual',
    });
  }, [keyword, history]);

  const closeSearchResultsDropdown = (e) => {
    if (!searchInputContainer.current?.contains(e.target)) {
      setIsOpenSearchResultDropdown(false);
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', closeSearchResultsDropdown);
    return () => {
      document.removeEventListener('mousedown', closeSearchResultsDropdown);
    };
  }, []);

  useEffect(() => {
    if (location?.pathname === '/favorite') {
      setKeyWord('');
      setTempKeyword('');
      clearSearchProductResults();
      return;
    }
    setKeyWord(search.filter?.query || '');
    setTempKeyword(search.filter?.query || '');
    if (!search.filter?.query) {
      clearSearchProductResults();
    }
  }, [location?.search]);

  return (
    <InputContainer ref={searchInputContainer} homePage={location?.pathname !== '/market'}>
      <CustomSearchInput
        ref={searchInput}
        onChange={onChangeSearch}
        onPressEnter={handleOnSearch}
        value={keyword}
        placeholder={`${translations(messages.searchProducts)}`}
        size="default"
        prefix={<SVGIcon src={SearchIcon} />}
      >
        <AntdInput
          onFocus={() => {
            setIsOpenSearchResultDropdown(true);
            if (!isOpenSearchResultDropdown) {
              sendGA4Event(EventName.SEARCH_FOCUS, {
                page_source: window.scrollY > 0 ? 'sticky_bar' : location?.pathname === '/' ? 'home' : 'header',
              });
            }
          }}
        />
      </CustomSearchInput>

      {isOpenSearchResultDropdown && (
        <Suspense fallback={<LoadingIndicator />}>
          <SearchWithDropDownComponent
            keyword={tempKeyword}
            onCloseDropdown={() => setIsOpenSearchResultDropdown(false)}
          />
        </Suspense>
      )}
    </InputContainer>
  );
};

export const SwitchRegionComponent: FC<{ region: string }> = ({ region }) => {
  const regionItems: MenuProps['items'] = [
    {
      key: 'HCM',
      label: (
        <RegionItem
          onClick={() => {
            window.localStorage.setItem('region', 'HCM');
            window.location.reload();
          }}
        >
          <RegionLabel>
            <FormattedMessage {...messages.southern} />
          </RegionLabel>
          {region === 'HCM' && <img src={CheckIcon} alt="Check Icon" width="20" height="20" loading="lazy" />}
        </RegionItem>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'HN',
      label: (
        <RegionItem
          onClick={() => {
            window.localStorage.setItem('region', 'HN');
            window.location.reload();
          }}
        >
          <RegionLabel>
            <FormattedMessage {...messages.northern} />
          </RegionLabel>
          {region === 'HN' && <img src={CheckIcon} alt="Check Icon" width="20" height="20" loading="lazy" />}
        </RegionItem>
      ),
    },
  ];
  return (
    <Viewport.Consumer>
      {({ width }) => {
        const isMobile = width < 768;
        return (
          <ChangeRegionContainer>
            <Dropdown
              menu={{ items: regionItems, selectable: true, defaultSelectedKeys: [region] }}
              placement="bottom"
              getPopupContainer={(triggerNode) => triggerNode.parentElement as HTMLElement}
            >
              <SwitchRegionContainer>
                {width > 767 && <LocationIcon />}
                <RegionContainer>
                  {region === 'HCM' ? (
                    <RegionName>
                      <FormattedMessage {...messages.southern} />
                    </RegionName>
                  ) : (
                    <RegionName>
                      <FormattedMessage {...messages.northern} />
                    </RegionName>
                  )}
                </RegionContainer>
                <ArrowDownIcon />
              </SwitchRegionContainer>
            </Dropdown>
          </ChangeRegionContainer>
        );
      }}
    </Viewport.Consumer>
  );
};

const TopNav: FC<ITopNavProps> = (props) => {
  const { onSignout, onSetLang, user, cart, store, permissions: userPermissions, onOpenSigninPopup } = props;

  const [lang, setLang] = usePopstateLanguage();
  const region = window.localStorage.getItem('region') || 'HCM';
  const loggedIn = !!localStorage.getItem('token');
  const fromQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [isOpenSideNav, setIsOpenSideNav] = useState(false);
  const [isOpenCategory, setIsOpenCategory] = useState(false);
  const [showTopHeader, setShowTopHeader] = useState(true);
  const lastScrollTop = useRef(0);
  const [showMobileItem, setShowMobileItem] = useState(false);

  const canAccessView = (path: string): boolean => {
    const permissions: string[] = viewPermissions[path];
    if (permissions) {
      let permissionCounter = 0;
      for (const permission of permissions) {
        if (userPermissions.indexOf(permission) > -1) {
          permissionCounter += 1;
        }
      }

      if (permissionCounter !== permissions.length) {
        return false;
      }
    }
    return true;
  };

  const items = [
    {
      label: 'VN',
      value: Language.Vi,
    },
    {
      label: 'EN',
      value: Language.En,
    },
  ];

  const [isSideBarMounted, setIsSideBarMounted] = useState<boolean>(false);
  const checkShowCategorySelector = useMemo(() => {
    const isFavoritePage = pathnameChecker.isOtherPage(location.pathname, '/favorite');
    const isMarketRoutes = pathnameChecker.isMarketRoutes(location.pathname);
    return {
      isShow: isFavoritePage || isMarketRoutes,
      isNotShow: !isFavoritePage && !isMarketRoutes,
    };
  }, [location.pathname]);

  const isFarmToTablePage = useMemo(() => location.pathname === '/tu-nong-trai-den-doanh-nghiep', [location.pathname]);

  const translateYValue = useMemo(() => {
    // const isHomePage = location.pathname === '/';
    // if (isFarmToTablePage) {
    //   return showTopHeader ? 0 : -107;
    // }
    // if (isHomePage) {
    //   return showTopHeader ? 0 : -36;
    // }
    return 0;
  }, [isFarmToTablePage, showTopHeader]);

  const handleToggleSideNav = () => {
    const bodyElement = document.querySelector('body');
    if (!isOpenSideNav && bodyElement) {
      bodyElement.classList.add('hideScroll');
      if (!isSideBarMounted) {
        setIsSideBarMounted(true);
      }
    } else if (bodyElement) {
      bodyElement.classList.remove('hideScroll');
    }
    setIsOpenSideNav(!isOpenSideNav);
  };
  const handleToggleCategory = () => {
    setIsOpenCategory(true);
  };

  const onScroll = useCallback(() => {
    requestAnimationFrame(() => {
      const scrollTop = window.scrollY;
      if (!showMobileItem && scrollTop > lastScrollTop.current && scrollTop > 55) {
        setShowMobileItem(true);
      } else if (scrollTop === 0) {
        setShowMobileItem(false);
      }
      lastScrollTop.current = scrollTop;
    });
  }, []);

  useEffect(() => {
    if (location.pathname !== '/') return;

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [location.pathname, onScroll]);

  useEffect(() => {
    /* Dispatch signout action when user click signout button from Kamereo blog */
    if (Object.keys(fromQuery).length && fromQuery.from === 'blog') {
      const action = fromQuery.action;
      switch (action) {
        case 'signout': {
          onSignout();
          break;
        }
        default:
          break;
      }
    }
  }, [location.search]);

  return (
    <Viewport.Consumer>
      {({ width }) => {
        const isMobile = width < 768;
        const isDesktop = width > 1024;
        const isTablet = width < 992;
        const notHomePage = location.pathname !== '/';
        return (
          <>
            <TopNavWrapper translateYValue={translateYValue}>
              <TopNavContent
                bgColor={width <= 991 ? (showMobileItem || notHomePage ? '#ffffff' : '#43A047') : undefined}
              >
                <LeftNav>
                  {isTablet && (
                    <div onClick={handleToggleSideNav}>
                      <HamburgerIcon color={showMobileItem || notHomePage ? '#4B5563' : undefined} />
                    </div>
                  )}
                  <TopNavLinkItem to="/" isLogoNav={true} aria-label="Kamereo logo">
                    <KamereoLogo
                      src={
                        width <= 991
                          ? showMobileItem || notHomePage
                            ? KamereoMascotOnly
                            : KamereoLogoMobileWhite
                          : Kamereo
                      }
                      alt="KAMEREO - Đối tác cung cấp thực phẩm uy tín"
                    />
                    {location.pathname === '/' && (
                      <VisuallyHidden asComponent="h1">KAMEREO - Đối tác cung cấp thực phẩm uy tín</VisuallyHidden>
                    )}
                  </TopNavLinkItem>
                  <>{process.env.APP_ENV === 'production' ? '' : <EnvIndicator>QA</EnvIndicator>}</>
                </LeftNav>
                {loggedIn ? (
                  <>
                    {isDesktop && (
                      <Link to="/change-store">
                        <SwitchStoreContainer>
                          <RestaurantIcon />
                          <StoreName>{store.name}</StoreName>
                          <ArrowDownIcon />
                        </SwitchStoreContainer>
                      </Link>
                    )}
                    <MiddleNav>
                      {width > 991 && (location.pathname !== '/market' || isDesktop) && (
                        <SearchProductComponent {...props} />
                      )}
                      {checkShowCategorySelector.isShow && width < 992 && location?.pathname !== '/market' && (
                        <Suspense fallback={<LoadingIndicator />}>
                          <MainCategoryNavMobile />
                        </Suspense>
                      )}
                      {isTablet && (
                        <Link to="/change-store">
                          <SwitchStoreContainer textColor={showMobileItem || notHomePage ? '#111827' : '#ffffff'}>
                            <StoreName>{store.name}</StoreName>
                            <ArrowDownIcon color={showMobileItem || notHomePage ? '#111827' : '#ffffff'} />
                          </SwitchStoreContainer>
                        </Link>
                      )}
                      {isTablet && (
                        <div className="top-nav-item">
                          <LinkText to="/notifications">
                            <HeaderIconWrapper
                              className={['/notifications'].includes(location.pathname) ? 'active' : ''}
                            >
                              <Notification color={!showMobileItem && !notHomePage ? '#ffffff' : ''} />
                            </HeaderIconWrapper>
                          </LinkText>
                        </div>
                      )}
                      {width <= 1024 && location.pathname.includes('/products/') && canAccessView('/cart') && (
                        <TopNavLinkItem to="/cart" className="no-padding">
                          <HeaderIconWrapper
                            className={location.pathname.split('/').includes('checkout') ? 'active' : ''}
                          >
                            <TopNavBadge>
                              {cart.cartSet.map((cartSet) => cartSet.items.length).reduce((a, b) => a + b, 0)}
                            </TopNavBadge>
                            <SVGIcon
                              src={Cart}
                              className="relative-position"
                              imgAttr={{ width: '24px', height: '24px' }}
                            />
                          </HeaderIconWrapper>
                        </TopNavLinkItem>
                      )}
                    </MiddleNav>
                    {/* right nav */}
                    {isDesktop && (
                      <RightNav className="login" transition={isDesktop && isFarmToTablePage && !showTopHeader}>
                        {isDesktop && (
                          <div className="top-nav-item">
                            <LinkText to="/notifications">
                              <HeaderIconWrapper
                                className={['/notifications'].includes(location.pathname) ? 'active' : ''}
                              >
                                <Notification />
                              </HeaderIconWrapper>
                            </LinkText>
                          </div>
                        )}
                        {isDesktop && (
                          <>
                            <LinkText to="/favorite">
                              <HeaderIconWrapper className={['/favorite'].includes(location.pathname) ? 'active' : ''}>
                                <SVGIcon src={FavoriteIcon} imgAttr={{ width: '27px', height: '24px' }} />
                              </HeaderIconWrapper>
                            </LinkText>
                          </>
                        )}
                        {isDesktop && (
                          <>
                            {canAccessView('/cart') && (
                              <TopNavLinkItem to="/cart" className="no-padding">
                                <HeaderIconWrapper
                                  className={location.pathname.split('/').includes('checkout') ? 'active' : ''}
                                >
                                  <TopNavBadge>
                                    {cart?.cartSet?.map((cartSet) => cartSet?.items?.length).reduce((a, b) => a + b, 0)}
                                  </TopNavBadge>
                                  <SVGIcon src={Cart} imgAttr={{ width: '24px', height: '24px' }} />
                                </HeaderIconWrapper>
                              </TopNavLinkItem>
                            )}
                          </>
                        )}
                        {isDesktop && (
                          <Suspense fallback={<LoadingIndicator />}>
                            <TopNavMenuItem
                              overlay={() => profileMenu(onSignout)}
                              trigger={['click']}
                              placement="bottomRight"
                              mgLeft
                            >
                              <ProfileInfoContainer user={user} />
                            </TopNavMenuItem>
                          </Suspense>
                        )}
                      </RightNav>
                    )}
                  </>
                ) : (
                  <>
                    {!isTablet && <SwitchRegionComponent region={region} />}
                    {!isTablet && (
                      <MiddleNav>
                        {(width > 576 || (width < 576 && checkShowCategorySelector.isNotShow)) &&
                          (location.pathname !== '/market' || isDesktop) && <SearchProductComponent {...props} />}
                        {checkShowCategorySelector.isShow && width < 1025 && location?.pathname !== '/market' && (
                          <Suspense fallback={<LoadingIndicator />}>
                            <MainCategoryNavMobile />
                          </Suspense>
                        )}
                      </MiddleNav>
                    )}
                    {/* right nav */}
                    <RightNav transition={isDesktop && isFarmToTablePage && !showTopHeader}>
                      {isDesktop && loggedIn && (
                        <LinkText to="/signin" rel="nofollow">
                          <HeaderIconWrapper className={['/favorite'].includes(location.pathname) ? 'active' : ''}>
                            <SVGIcon src={FavoriteIcon} alt="Favorite" />
                          </HeaderIconWrapper>
                        </LinkText>
                      )}
                      {isTablet && (
                        <SwitchStoreMobileContainer>
                          {(showMobileItem || notHomePage) && <SwitchRegionComponent region={region} />}
                          <Link to="/signin">
                            <MobileLoginButton bgColor={showMobileItem ? 'rgb(67, 160, 71)' : null}>
                              <FormattedMessage {...messages.signin} />
                            </MobileLoginButton>
                          </Link>
                        </SwitchStoreMobileContainer>
                      )}
                      {isDesktop && (
                        <>
                          <LinkText to="/cart" rel="nofollow">
                            <HeaderIconWrapper
                              className={location.pathname.split('/').includes('checkout') ? 'active' : ''}
                            >
                              <SVGIcon src={Cart} alt="Checkout" />
                              <TopNavBadge>
                                {cart?.cartSet?.map((cartSet) => cartSet.items.length).reduce((a, b) => a + b, 0)}
                              </TopNavBadge>
                            </HeaderIconWrapper>
                          </LinkText>
                        </>
                      )}
                      <SignInSignUpWrapper>
                        <TopNavButtonHiddenOnMobile isBtnText={true} onClick={() => onOpenSigninPopup(true)}>
                          <FormattedMessage {...messages.signin} />
                        </TopNavButtonHiddenOnMobile>
                        <LinkText to="/contact-us">
                          <TopNavButtonHiddenOnMobile className="contact-us">
                            <Button type="primary" size="small">
                              <FormattedMessage {...messages.signup} />
                            </Button>
                          </TopNavButtonHiddenOnMobile>
                        </LinkText>
                      </SignInSignUpWrapper>
                    </RightNav>
                  </>
                )}
              </TopNavContent>
              <AnimatePresence>
                {isTablet && (showMobileItem || location.pathname !== '/') && (
                  <motion.div
                    key="mobile-search"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25, ease: 'easeInOut' }}
                    style={{ overflow: 'hidden' }}
                  >
                    <SearchProductComponentMobileWrapper>
                      <SearchProductComponent {...props} />
                    </SearchProductComponentMobileWrapper>
                  </motion.div>
                )}
              </AnimatePresence>
              {isDesktop && (
                <>
                  {!(isFarmToTablePage && !showTopHeader) && (
                    <TopNavTopContentWrapper>
                      <div style={{ display: isOpenCategory ? 'block' : 'none' }}>
                        <CategoryMegaMenu
                          onClose={() => {
                            setIsOpenCategory(false);
                          }}
                        />
                      </div>
                      <TopNavTopContent>
                        <TopNavTopContentLeft>
                          <SubBarCategoryToggle onClick={handleToggleCategory}>
                            <CategoriesNavIcon />
                            <FormattedMessage {...messages.category} />
                            <ArrowDown />
                          </SubBarCategoryToggle>
                        </TopNavTopContentLeft>
                        <FeaturesList>
                          <FeatureItem>
                            <SVGIcon src={TruckIcon} />
                            <FormattedMessage {...topNavMessage.featureDelivery} />
                          </FeatureItem>
                          <FeatureItem>
                            <SVGIcon src={InvoiceIcon} />
                            <FormattedMessage {...topNavMessage.featureVat} />
                          </FeatureItem>
                          <FeatureItem>
                            <SVGIcon src={ReturnIcon} />
                            <FormattedMessage {...topNavMessage.featureReturn} />
                          </FeatureItem>
                          <FeatureItem>
                            <SVGIcon src={SupportIcon} />
                            <FormattedMessage {...topNavMessage.featureSupport} />
                          </FeatureItem>
                        </FeaturesList>
                        <TopNavTopContentRight>
                          <div className="top-nav-item">
                            <QuickOrderLink />
                          </div>
                          <div className="top-nav-item">
                            <KamereoInfo />
                          </div>
                          <LangSwitcherWrapper>
                            <SVGIcon src={GlobalIcon} />
                            <LangSwitcher
                              animation={false}
                              options={items}
                              value={lang}
                              onChange={(value) => {
                                setLang(value);
                                onSetLang(value);
                              }}
                            />
                          </LangSwitcherWrapper>
                        </TopNavTopContentRight>
                      </TopNavTopContent>
                    </TopNavTopContentWrapper>
                  )}
                  {!loggedIn && (
                    <HomePageBottomHeader
                      setShowTopHeaderCallback={(state) => {
                        if (state !== showTopHeader) {
                          setShowTopHeader(state);
                        }
                      }}
                    />
                  )}
                </>
              )}
              <FarmToBusinessHeader setShowTopHeaderCallback={setShowTopHeader} />
            </TopNavWrapper>
            <TopNavCategory cart={cart} permissions={userPermissions} />
            <Suspense fallback={<LoadingIndicator />}>
              {isSideBarMounted && (
                <SideNavMobileComponent
                  onCloseSideNav={handleToggleSideNav}
                  opened={isOpenSideNav}
                  onSetLang={onSetLang}
                  onSignout={onSignout}
                />
              )}
            </Suspense>
          </>
        );
      }}
    </Viewport.Consumer>
  );
};

export default withRouter(TopNav);
